var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":"","sm10":"","mt-2":""}},[_c('v-card',{staticClass:"elevation-3"},[(_vm.notes)?_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.formattedNotes)}}):_c('v-card-text',{staticClass:"text-xs-center py-5"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":50,"color":"primary"}})],1)],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-822e2de8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoteDisplay.vue
// module id = 182
// module chunks = 1